import * as _ from 'lodash';

export const isValidOs = () => {
  let os = getOsByUserAgent();

  if (_.isNil(os.name) || _.isNil(os.architecture) || _.isNil(os.platform)) {
    return false;
  }

  return true;
};

export const getOsByUserAgent = () => {
  let ua = navigator.userAgent;
  let os = { name: null, platform: null, architecture: null };

  if (ua.includes('Windows')) {
    os.name = 'PC';
    os.platform = 'windows';

    if (ua.includes('Win64') || ua.includes('WOW64')) {
      os.architecture = 'amd64';
    } else {
      os.architecture = 'i386';
    }
  }

  if (ua.includes('Linux')) {
    os.name = 'Debian';
    os.platform = 'debian';

    if (ua.includes('x86_64')) {
      os.architecture = 'amd64';
    } else {
      os.architecture = 'i386';
    }
  }

  if (ua.includes('Mac')) {
    os.name = 'Mac';
    os.platform = 'mac';

    if (ua.includes('PPC')) {
      os.architecture = 'i386';
    } else {
      os.architecture = 'amd64';
    }
  }

  return os;
};
